import type { NavigationGuardWithThis } from 'vue-router';

export default (indexName: string, redirectName: string) =>
  <NavigationGuardWithThis<undefined>>((to, _from, next) => {
    if (to.name === indexName) {
      return next({ name: redirectName });
    }
    return next();
  });
